import { GoTrash } from "react-icons/go";
import { useEffect, useState } from "react";
import { CiSquarePlus } from "react-icons/ci";
import { Form, Button, Row, Col, InputGroup } from "react-bootstrap";
import SitePilotAddonsEditor from "./SitePilotAddonsEditor";
import Swal from "sweetalert2";
import { addonsServices } from "../../../APIServices/SitePilotManagement/addonsServices";
import { FiDollarSign, FiPlus } from "react-icons/fi";
import UseToggle from "../../../Hooks/UseToggle";
import UploadedImageModal from "../SitePilotIntegration/UploadedImageModal";
import { FaTrashAlt } from "react-icons/fa";

const UpdateSitePilotAddons = ({ getSitePilotAddonsList, getSingleSitePilotAddons, singleSitePilotAddons }) => {
  const [tags, setTags] = useState([]);
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("");
  const [hourlyPrice, setHourlyPrice] = useState(0);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [yearlyPrice, setYearlyPrice] = useState(0);
  const [icon, setIcon] = useState("");
  const [title, setTitle] = useState("");
  const [overview, setOverview] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [banner, setBanner] = useState([]);
  const [bannerIndex, setBannerIndex] = useState(null);
  const [sliders, setSliders] = useState(false);
  const [chatWithUs, setChatWithUs] = useState(false);
  const [scheduleCall, setScheduleCall] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const toggles = UseToggle();

  const updatedSitePilotAddons = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this addons?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      let userData = {};
      userData.addonId = singleSitePilotAddons?.addonId;
      userData.title = title;
      userData.status = status;
      userData.banners = banner
      userData.hourlyPrice = hourlyPrice
      userData.monthlyPrice = monthlyPrice
      userData.yearlyPrice = yearlyPrice
      userData.icon = icon
      userData.shortDescription = shortDescription;
      userData.overview = overview;
      userData.sliders = sliders;
      userData.sliderType = true;
      userData.chatWithUs = chatWithUs;
      userData.scheduleCall = scheduleCall;
      userData.faqType = true;
      userData.faqs = faqs;
      userData.tagType = true;
      userData.tags = tags;
      let data = await addonsServices.updatedSitePilotAddon(userData);
      if (data?.statusCode === 200) {
        getSitePilotAddonsList();
        getSingleSitePilotAddons();
        clearData();
      }
      setLoader(false);
    });
  };

  const clearData = () => {
    setTitle("");
    setShortDescription("");
    setOverview("");
    setTags([]);
    setBanner([]);
    setStatus("");
    setLoader(false);
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  const hasEmptyTag = () => {
    return tags?.some((tag) => tag.trim() === "");
  };

  const addFaqsRow = () => {
    setFaqs([...faqs, { question: "", answer: "" }]);
  };

  const removeFaqsRow = (index) => {
    setFaqs(faqs.filter((_, i) => i !== index));
  };

  const handleFaqsChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  const isFaqInvalid = () => {
    return faqs.some(
      (item) =>
        !item.question?.trim() || !item.answer?.trim()
    );
  };

  const addBannerUrl = (url) => {
    setBanner((prev) => [...prev, url]);
  };

  const updateBannerUrl = (newUrl) => {
    setBanner((prev) =>
      prev.map((item, i) => (i === bannerIndex ? newUrl : item))
    );
  };

  const removeBannerUrl = (index) => {
    setBanner((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (singleSitePilotAddons) {
      setIcon(singleSitePilotAddons?.icon || "");
      setTitle(singleSitePilotAddons?.title || "");
      setShortDescription(singleSitePilotAddons?.shortDescription || "");
      setHourlyPrice(singleSitePilotAddons?.hourlyPrice || "");
      setMonthlyPrice(singleSitePilotAddons?.monthlyPrice || "");
      setYearlyPrice(singleSitePilotAddons?.yearlyPrice || "");
      setOverview(singleSitePilotAddons?.overview || "");
      setSliders(singleSitePilotAddons?.sliders || false);
      setScheduleCall(singleSitePilotAddons?.scheduleCall || false);
      setChatWithUs(singleSitePilotAddons?.chatWithUs || false);
      setTags(singleSitePilotAddons?.tags || []);
      setBanner(singleSitePilotAddons?.banners || []);
      setFaqs(singleSitePilotAddons?.faqs || []);
      setStatus(singleSitePilotAddons?.status);
    }
  }, [singleSitePilotAddons]);

  console.log("singleSitePilotAddons>>>>>>", singleSitePilotAddons);
  

  return (
    <div>
      <Form>
        <div
          className="overflow-auto p-3"
          style={{ height: "calc(100vh - 169px)" }}
        >
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Icon
                </Form.Label>
                <div title="Add Icon">
                  <Button
                    onClick={toggles.setToggle}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    {icon ? (
                      <img className="w-auto h-50" src={icon} />
                    ) : (
                      <>
                        <FiPlus /> Add Icon
                      </>
                    )}
                  </Button>
                </div>
              </Form.Group>
            </Col>
            <Col md={9}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Title
                </Form.Label>
                <Form.Control
                  type="text"
                  style={{ fontSize: 12 }}
                  placeholder="Enter Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              <Col>
                <Row>
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label
                        className="fw-bold mb-1"
                        style={{ fontSize: 13 }}
                      >
                        Status
                      </Form.Label>
                      <Form.Select
                        style={{ fontSize: 12 }}
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value={"active"}>Active</option>
                        <option value={"inactive"}>Inactive</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-3 hstack gap-2">
                      <Form.Check
                        type="switch"
                        checked={chatWithUs}
                        onChange={(e) => setChatWithUs(e.target.checked)}
                        style={{ fontSize: 12 }}
                      />
                      <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                        Chat With Us (Button)
                      </Form.Label>
                    </Form.Group>
                    <Form.Group className="mb-3 hstack gap-2">
                      <Form.Check
                        type="switch"
                        checked={scheduleCall}
                        onChange={(e) => setScheduleCall(e.target.checked)}
                        style={{ fontSize: 12 }}
                      />
                      <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                        Schedule Call (Button)
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <div className="hstack gap-2 mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Banner
              </Form.Label>
              <div className="vr"></div>
              <Form.Group className="mb-1 hstack gap-2">
                <Form.Check
                  type="switch"
                  checked={sliders}
                  onChange={(e) => setSliders(e.target.checked)}
                  style={{ fontSize: 12 }}
                />
                <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                  Slider
                </Form.Label>
              </Form.Group>
            </div>
            <Row className="g-2">
              {banner?.map((icon, index) => (
                <Col key={index} md={3}>
                  <div title="Remove Banner" className="position-relative">
                    <Button
                      onClick={() => { toggles.setToggle2(); setBannerIndex(index) }}
                      variant="light"
                      className="w-100 border hstack gap-2 justify-content-center"
                      style={{ height: 108 }}
                    >
                      <img className="w-auto h-50" src={icon} />
                    </Button>
                    <div className="bg-white position-absolute rounded-circle" style={{top: -10, right: -3}}>
                      <Button variant="outline-danger" className="rounded-circle p-0" style={{width: 25}} onClick={() => removeBannerUrl(index)}>
                        <FaTrashAlt style={{fontSize: 12}}/>
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
              <Col md={3}>
                <div title="Add Banner">
                  <Button
                    onClick={toggles.setToggle1}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    <FiPlus /> Add Banner
                  </Button>
                </div>
              </Col>
            </Row>
          </Form.Group>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Hourly Price
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FiDollarSign style={{ fontSize: 12 }} />
                  </InputGroup.Text>
                  <Form.Control
                    type="number"
                    onChange={(e) => setHourlyPrice(e.target.value)}
                    value={hourlyPrice}
                    placeholder="Enter Hourly Price"
                    style={{ fontSize: 12 }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Monthly Price
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FiDollarSign style={{ fontSize: 12 }} />
                  </InputGroup.Text>
                  <Form.Control
                    type="number"
                    onChange={(e) => setMonthlyPrice(e.target.value)}
                    value={monthlyPrice}
                    placeholder="Enter Monthly Price"
                    style={{ fontSize: 12 }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Yearly Price
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FiDollarSign style={{ fontSize: 12 }} />
                  </InputGroup.Text>
                  <Form.Control
                    type="number"
                    onChange={(e) => setYearlyPrice(e.target.value)}
                    value={yearlyPrice}
                    placeholder="Enter Yearly Price"
                    style={{ fontSize: 12 }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Short Description
            </Form.Label>
            <Form.Control
              as="textarea"
              style={{ fontSize: 12 }}
              placeholder="Enter Short Description"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Overview
            </Form.Label>
            <SitePilotAddonsEditor
              editorValue={overview}
              setEditorValue={setOverview}
            />
          </Form.Group>
          <Form.Group>
            <div className="hstack gap-2 mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                FAQs
              </Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addFaqsRow}
                className="mb-1 text-success CP"
              />
            </div>

            <Row>
              {faqs?.map((item, index) => (
                <Col md={6} className="mb-2" key={index}>
                  <InputGroup className="mb-1">
                    <Form.Control
                      placeholder="Enter Question"
                      value={item.question}
                      style={{ fontSize: 12 }}
                      onChange={(e) =>
                        handleFaqsChange(index, "question", e.target.value)
                      }
                    />
                  </InputGroup>

                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter Answer"
                      value={item.answer}
                      style={{ fontSize: 12 }}
                      onChange={(e) =>
                        handleFaqsChange(index, "answer", e.target.value)
                      }
                    />
                    <InputGroup.Text>
                      <GoTrash
                        style={{ fontSize: 12 }}
                        className="text-danger CP"
                        title="Delete"
                        onClick={() => removeFaqsRow(index)}
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </Col>
              ))}
            </Row>
          </Form.Group>
          <Form.Group>
            <div className="hstack gap-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Tags
              </Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addTagsRow}
                className="mb-1 text-success CP"
              />
            </div>
            <Row>
              {tags?.map((tag, index) => {
                return (
                  <Col md={3} className="mb-2">
                    <InputGroup key={index}>
                      <Form.Control
                        placeholder="Enter Tag"
                        value={tag}
                        style={{ fontSize: 12 }}
                        onChange={(e) =>
                          handleTagsChange(index, e.target.value)
                        }
                      />
                      <InputGroup.Text>
                        <GoTrash
                          style={{ fontSize: 12 }}
                          className="text-danger CP"
                          title="Delete"
                          onClick={() => removeTagsRow(index)}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                );
              })}
            </Row>
          </Form.Group>
        </div>
        <div className="d-flex justify-content-end gap-2 p-2">
          <Button variant="light" style={{ fontSize: 12 }} onClick={clearData}>
            Cancel
          </Button>

          <Button
            disabled={
              !icon ||
              !title ||
              !monthlyPrice ||
              !yearlyPrice ||
              banner?.length === 0 ||
              !shortDescription ||
              !overview ||
              loader ||
              isFaqInvalid() ||
              hasEmptyTag()
            }
            onClick={updatedSitePilotAddons}
            style={{ fontSize: 12 }}
          >
            Save
          </Button>
        </div>
      </Form>
      <UploadedImageModal
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title={`Media Library`}
        onSelect={(icon) => setIcon(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title={`Media Library`}
        onSelect={(icon) => addBannerUrl(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        Title={`Media Library`}
        onSelect={(icon) => updateBannerUrl(icon)}
      />
    </div>
  );
};

export default UpdateSitePilotAddons;